import {
  addDays,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths,
} from 'date-fns';
import { formatDateToQuery } from 'helpers/Date';
import { PeriodsFilters } from 'redux/types/FiltersTypes';

export const getPeriodsDates = (period) => {
  let start;
  let end;

  switch (period) {
  case PeriodsFilters.LAST_3_DAYS:
    start = addDays(new Date(), -3);
    break;

  case PeriodsFilters.WEEK:
    start = addWeeks(new Date(), -1);
    break;

  case PeriodsFilters.MONTH: {
    const current = new Date();

    start = startOfMonth(current);
    break;
  }

  case PeriodsFilters.LAST_MONTH: {
    const current = new Date();
    const prevMonth = addMonths(current, -1);

    start = startOfMonth(prevMonth);
    end = endOfMonth(prevMonth);
    break;
  }

  default:
    break;
  }

  return {
    start: start ? formatDateToQuery(start) : null,
    end: end ? formatDateToQuery(end) : null,
  };
};
